module.exports = "https://cdn-shared.mathletics.com/teacher-modules/upf-assign/73/assets/images/cddd612e908cd6e6f57ab33d5266a340.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_step_5.svg
// module id = sY2n
// module chunks = 0